export const CONFERENCE_SUB_TABS = {
    DETAILS: {
        name: 'details',
        caption: 'Details',
    },
    ADVERTISEMENT: {
        name: 'advertisement',
        caption: 'Advertisement',
    },
    CONTENT: {
        name: 'content',
        caption: 'Content',
    },
};

export const START_DATE_CONTROL = 'start-date-control';
export const START_DATE_REQUIRED_ERROR = 'start-date-required-error';
export const START_DATE_REQUIRED_MESSAGE = 'Start date is required field';

export const END_DATE_CONTROL = 'end-date-control';
export const END_DATE_REQUIRED_ERROR = 'end-date-required-error';
export const END_DATE_REQUIRED_MESSAGE = 'End date is required field';

export const LICENSE_END_DATE_BEFORE_START_DATE_ERROR = 'LICENSE_END_DATE_BEFORE_START_DATE_ERROR';
export const LICENSE_END_DATE_BEFORE_START_DATE_MESSAGE = 'End date should be after start date';

export const CONFERENCE_NAME_CONTROL = 'conference-name-control';
export const CONFERENCE_NAME_REQUIRED_ERROR = 'CONFERENCE_NAME_REQUIRED_ERROR';
export const CONFERENCE_NAME_REQUIRED_MESSAGE = 'The Conference Name is a required field';
